/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, November 11th 2021, 10:50:19 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { TextField, TextFieldProps } from "@mui/material";
import { OSFormInputProps, useUncontrolledInput } from "ui-widgets/forms";
import { useOSFormContext } from "ui-widgets/forms/providers";
import {
  APIFormInputErrorWrapper,
  CustomInputValidationErrorWrapper,
  HelperTextInputWrapper,
} from "ui-widgets/forms/FormInputWrappers";

export type TextFormInputProps<T> = OSFormInputProps<T> &
  TextFieldProps & {
    autoTrim?: boolean;
  };

export const TextFormInput = <T,>({ autoTrim = false, ...props }: TextFormInputProps<T>) => {
  const { uncontrolledProps } = useUncontrolledInput<T>(props);

  const { watch, setValue } = useOSFormContext<T>();

  const watchedValue = watch(props.schema_field_key as any) as string;

  React.useEffect(() => {
    if (!autoTrim) return;

    if (watchedValue.includes(" ")) setValue(props.schema_field_key as any, watchedValue.trim() as any);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchedValue, autoTrim]);

  return (
    <APIFormInputErrorWrapper schema_field_key={props.schema_field_key} label={props.label}>
      <CustomInputValidationErrorWrapper schema_field_key={props.schema_field_key} label={props.label}>
        <HelperTextInputWrapper helperText={props.helperText}>
          <TextField
            label={props.label}
            placeholder={props.placeholder}
            fullWidth={props.fullWidth}
            {...uncontrolledProps}
            {...props}
            helperText={null}
          />
        </HelperTextInputWrapper>
      </CustomInputValidationErrorWrapper>
    </APIFormInputErrorWrapper>
  );
};
